/**
 * 登录页面常量配置
 */

// OAuth配置
export const OAUTH_CONFIG = {
  CLIENT_ID: '9db5bfc177c993c6487d3a6d74e196e59f28003d53b2783955054a411a0e136b',
  AUTHORIZE_URL: 'https://git.wsc.tech/oauth/authorize',
  SCOPE: 'openid api',
  RESPONSE_TYPE: 'code'
};

// 品牌特色文案
export const BRAND_FEATURES = [
  { text: '快速响应' },
  { text: '有效服务' },
  { text: '成人达已' }
];

// 版权信息
export const COPYRIGHT_INFO = {
  START_YEAR: 2013,
  COMPANY: '昆明贯石科技有限公司',
  ICP: '滇ICP备 13004120号'
};

// 表单验证规则
export const VALIDATION_RULES = {
  PHONE_REGEX: /^1[3-9]\d{9}$/,
  REQUIRED_MESSAGES: {
    ACCOUNT: '请输入账号',
    PASSWORD: '请输入密码',
    PHONE: '请输入正确的手机号',
    VERIFY_CODE: '请输入验证码'
  }
};

// 登录方式配置
export const LOGIN_TABS = {
  ACCOUNT: 'account',
  PHONE: 'phone',
  QRCODE: 'qrcode'
};